import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container footer-content">
                <div className="footer-section company-info">
                    <h3>P&C Property Management</h3>
                    <p>Professional residential management with a focus on efficiency and elevated service.</p>
                </div>

                <div className="footer-section contact-info">
                    <h4>Contact Us</h4>
                    <p>Email: cindy@pcpropertymgmt.com</p>
                    <div className="locations">
                        <p><strong>London Office:</strong><br />25 Alomar Drive, London ON N6K 4X4</p>
                        <p><strong>Markham Office:</strong><br />43 Hendon Rd., Markham ON L3R 6Z6</p>
                    </div>
                </div>

                <div className="footer-section quick-links">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/services">Services</a></li>
                        <li><a href="/tenants">Tenants</a></li>
                        <li><a href="/contact">Contact</a></li>
                    </ul>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container">
                    <p>&copy; {new Date().getFullYear()} P&C Property Management. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
